import React from "react";
import { Card, Tag } from "antd";
import { VisualSeoSuggestion } from "../types";
import { getEffortTagColor, getImpactTagColor } from "./utils";

const { Meta } = Card;

type Props = {
    suggestions: VisualSeoSuggestion[];
}

export default function PriorityFixesCard({ suggestions }: Props) {
    return (
        <Card
            className="visual-seo-priority-fixes-card"
            title={
                <Meta title={"Suggested improvements"} description={"Ranked by effort and impact"} />
            }
        >
            <ul className="priority-fixes-list">
                {suggestions.map((suggestion, index) => (
                    <li key={index}>
                        <span className="fix-action" dangerouslySetInnerHTML={{ __html: suggestion.action }} />
                        <div className="fix-tags">
                            <Tag color={getEffortTagColor(suggestion.effort)}>Effort: {suggestion.effort}</Tag>
                            <Tag color={getImpactTagColor(suggestion.impact)}>Impact: {suggestion.impact}</Tag>
                        </div>
                    </li>
                ))}
            </ul>
        </Card>
    );
}
